function Header() {

    return (
        <>
            <div className="section-label">
                Search Filters
            </div>

            {/*
            <div className="section-meta">
                <a href="https://www.toxicdocs.org/advanced-search/">advanced doc keyword search (link to be added)</a>
            </div>
            */}
        </>
    )
}

export default Header;